import { useState } from 'react'

interface SearchArgs {
  searchValue?: string
  onSearch?: (text: string) => void
}

export interface SelectSearch {
  query: string
  setQuery: (text: string, reason: string) => void
  resetQuery: () => void
}

// The search text: controlled by `searchValue`, else owned here. Only typing
// and clearing reach `onSearch` — Base UI also echoes a picked item's label
// into the input, which is not a search.
export const useSelectSearch = ({
  searchValue,
  onSearch,
}: SearchArgs): SelectSearch => {
  const [inner, setInner] = useState('')
  const query = searchValue ?? inner

  const setQuery = (text: string, reason: string): void => {
    if (reason !== 'input-change' && reason !== 'input-clear') return
    setInner(text)
    onSearch?.(text)
  }

  // A controlled `searchValue` is the caller's to reset.
  const resetQuery = (): void => {
    if (searchValue !== undefined || inner === '') return
    setInner('')
    onSearch?.('')
  }

  return { query, setQuery, resetQuery }
}
